import { a as D, j as c, o as f } from "./format-Cc3xCl5M.js";
const Y = (t, e, n) => {
  const a = new Date(e, t, 1 - ((n == null ? void 0 : n.weekStartDay) || 0)).getDay(), y = new Date(e, t + 1, 0).getDate(), o = [], s = t === 0 ? 11 : t - 1, u = new Date(s === 11 ? e - 1 : e, s + 1, 0).getDate();
  let r = u - a + 1;
  r === u + 1 && (r = 1);
  const h = (m) => f(m, n == null ? void 0 : n.locale);
  for (let m = 0; m < a; m++)
    o.push({ value: h(r + m), month: "prev" });
  for (let m = 1; m <= y; m++)
    o.push({ value: h(m), month: "current" });
  const d = 35 - o.length >= 0 ? 35 - o.length : 42 - o.length;
  for (let m = 1; m <= d; m++)
    o.push({ value: h(m), month: "next" });
  return o;
}, w = () => {
  const t = /* @__PURE__ */ new Date();
  return { day: t.getDate(), month: t.getMonth(), year: t.getFullYear() };
};
function b(t, e) {
  const n = [];
  for (let a = e; a >= t; a--)
    n.push(a);
  return n;
}
const M = (/* @__PURE__ */ new Date()).getFullYear(), i = (t, e) => e === "prev" ? t === 0 ? 11 : t - 1 : e === "next" ? t === 11 ? 0 : t + 1 : t, l = (t, e, n) => n === "prev" ? e === 0 ? t - 1 : t : n === "next" && e === 11 ? t + 1 : t, k = (t, e) => ({ year: e === 0 ? t - 1 : t, month: e === 0 ? 11 : e - 1 }), T = (t, e) => ({ year: e === 11 ? t + 1 : t, month: e === 11 ? 0 : e + 1 });
function L(t, e) {
  const n = [];
  for (let a = 0; a < t.length; a += e)
    n.push(t.slice(a, a + e));
  return n;
}
const j = ({ startDay: t, month: e, year: n, type: a, setStartDay: y }) => {
  if (a === "single") {
    const o = { ...t || w(), ...e !== void 0 && { month: e }, ...n !== void 0 && { year: n } };
    return y == null || y(o), { selectedDate: o, type: a };
  }
  return null;
}, p = () => {
  const t = /* @__PURE__ */ new Date();
  return { day: t.getDate(), month: t.getMonth(), year: t.getFullYear() };
}, E = (t) => {
  const e = p();
  return t instanceof Date ? t.getDate() === e.day && t.getMonth() === e.month && t.getFullYear() === e.year : t.day === e.day && t.month === e.month && t.year === e.year;
}, q = (t, e) => {
  const n = t instanceof Date ? t : D(t), a = e instanceof Date ? e : D(e);
  return n.getTime() < a.getTime();
}, R = (t, e = "long", n) => new Date(2e3, t, 1).toLocaleString(n ?? "en", { month: e }), W = (t, e) => {
  const n = (a) => {
    t && !t.contains(a.target) && e(a);
  };
  return document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  };
}, z = ({ day: t, endDate: e, startDate: n, year: a, month: y, monthStatus: o }) => {
  if (!n || !e)
    return !1;
  const s = new Date(l(a, y, o), i(y, o), t), u = new Date(n.year, n.month, n.day), r = new Date(e.year, e.month, e.day);
  return s > u && s < r;
}, A = ({ dateRange: t, day: e, year: n, month: a, monthStatus: y }) => {
  if (!t)
    return !1;
  const o = new Date(l(n, a, y), i(a, y), e), s = new Date(t.year, t.month, t.day);
  return o.getTime() === s.getTime();
}, B = ({ maxDate: t, minDate: e, day: n, year: a, month: y }) => {
  if (!e && !t)
    return !1;
  const o = new Date(l(c(a), c(y), n.month), i(c(y), n.month), n.value);
  if (e && t) {
    const s = new Date(e.year, e.month, e.day), u = new Date(t.year, t.month, t.day);
    return o < s || o > u;
  }
  return e ? o < new Date(e.year, e.month, e.day) : t ? o > new Date(t.year, t.month, t.day) : !1;
}, x = ({ disabledDays: t, month: e, day: n, year: a }) => !!t && !!t.find((y) => {
  if ("start" in y && "end" in y) {
    const o = D(y.start), s = D(y.end), u = D({ day: n.value, month: i(e, n.month), year: l(a, e, n.month) });
    return u >= o && u <= s;
  }
  return y.day === n.value && y.month === i(e, n.month) && y.year === l(a, e, n.month);
}), S = ({ enabledDays: t, day: e, year: n, month: a, next: y, prev: o }) => !!t && t.every((s) => {
  const u = e ? { day: e.value, month: i(a, e.month), year: l(n, a, e.month) } : { year: n, month: a };
  if ("start" in s && "end" in s) {
    if (function(r, h, d, m) {
      if (m != null && m.next)
        return h.year === void 0 || r.year === void 0 || h.year > r.year || r.year === h.year && (r.month === void 0 || h.month === void 0 || h.month >= r.month);
      if (m != null && m.prev)
        return d.year === void 0 || r.year === void 0 || d.year < r.year || r.year === d.year && (r.month === void 0 || d.month === void 0 || d.month <= r.month);
      const v = h.year === void 0 || r.year === void 0 || r.year > h.year || r.year === h.year && (r.month === void 0 || h.month === void 0 || r.month > h.month || r.month === h.month && (!r.day || h.day === void 0 || r.day >= h.day)), g = d.year === void 0 || r.year === void 0 || r.year < d.year || r.year === d.year && (r.month === void 0 || d.month === void 0 || r.month < d.month || r.month === d.month && (!r.day || d.day === void 0 || r.day <= d.day));
      return v && g;
    }(u, s.start, s.end, { next: y, prev: o }))
      return !1;
  } else if (function(r, h) {
    return r.day ? r.year === h.year && r.month === h.month && r.day === h.day : r.year === h.year && r.month === h.month;
  }(u, s))
    return !1;
  return !0;
}), C = (t, e, n) => {
  for (let a = new Date(t); a <= e; a.setDate(a.getDate() + 1))
    if (x({ day: { month: "current", value: a.getDate() }, month: a.getMonth(), year: a.getFullYear(), disabledDays: n }))
      return !0;
  return !1;
}, G = (t, e, n) => {
  for (let a = new Date(t); a <= e; a.setDate(a.getDate() + 1))
    if (S({ day: { month: "current", value: a.getDate() }, month: a.getMonth(), year: a.getFullYear(), enabledDays: n }))
      return !0;
}, H = ({ year: t, month: e, day: n }) => {
  const a = i(e, n.month), y = l(t, e, n.month), o = new Date(y, a, n.value).getDay();
  return { isWeekend: o === 0 || o === 6, isSaturday: o === 6, isSunday: o === 0 };
}, I = (t, e) => t.day === e.day && t.month === e.month && t.year === e.year;
export {
  R as a,
  W as b,
  E as c,
  S as d,
  j as e,
  i as f,
  p as g,
  A as h,
  q as i,
  z as j,
  l as k,
  H as l,
  x as m,
  B as n,
  I as o,
  C as p,
  G as q,
  L as r,
  M as s,
  b as t,
  T as u,
  k as v,
  Y as w
};
